import React, { Component } from 'react';
import b from 'b_';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import ICustomPage from '@interfaces/custom-page';
import PageMeta from '@components/page-meta';
import CustomPageStub from './custom-page.stub';

export interface DispatchProps {
    fetchCustomPage(): void;
}

export interface StateProps {
    data: ICustomPage;
    isLoading: boolean;
    match?: any;
}

type Props = StateProps & DispatchProps & RouteComponentProps<{}>;

const class_ = b.with('custom-page');

class CustomPage extends Component<Props> {
    public componentDidMount() {
        const { fetchCustomPage, data, match } = this.props;
        const { slug } = match.params;

        if (!data.slug || data.slug !== slug) {
            fetchCustomPage();
        }
    }

    public componentDidUpdate(prevProps: Props) {
        const { match, fetchCustomPage } = this.props;

        if (match.params.slug !== prevProps.match.params.slug) {
            fetchCustomPage();
        }
    }

    public shouldComponentUpdate() {
        return true;
    }

    public render() {
        const { data, isLoading } = this.props;

        if (isLoading || !data || !data.id) {
            return <CustomPageStub />;
        }

        return (
            <div className="centering">
                <PageMeta title={data.title} description={data.content} />
                <div
                    className={`${class_()} wysiwyg-content`}
                    dangerouslySetInnerHTML={{ __html: data.content }}
                />
            </div>
        );
    }
}

export default withRouter(CustomPage);
